<template>
	<div class="ingredients-slider swiper-container" ref="slider">
		<div class="swiper-wrapper">
			<div
				v-for="(ingredient, index) in ingredients"
				:key="index"
				class="swiper-slide ingredient-container"
				:style="{ backgroundImage: `url(${resizeImage(ingredient.image)})` }"
			></div>
		</div>
		<div class="content">
			<div class="content__container">
				<div class="box">
					<h4 class="box__title">{{ currentIngredient.ingredient }}</h4>
					<div class="box__content" v-html="currentIngredient.description" />

					<div class="meta">
						<div class="meter">
							<div class="progress" ref="progressBar"></div>
						</div>
						<div class="page">
							{{ currentIndex + 1 }}/{{ ingredients.length }}
						</div>
						<div class="navigation">
							<div class="navigation__button navigation__button--prev">
								<i class="fal fa-chevron-left"></i>
							</div>
							<div class="navigation__button navigation__button--next">
								<i class="fal fa-chevron-right"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";;
import smoothReflow from "vue-smooth-reflow";

export default {
	mixins: [smoothReflow],
	props: {
		ingredients: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			currentIndex: 0,
			timestamp: Date.now(),
			delay: 5000
		};
	},
	computed: {
		currentIngredient() {
			return this.ingredients[this.currentIndex];
		}
	},
	methods: {
		resizeImage(url) {
			return url.replace(/(\.[^\.]+)$/i, "_1440x$1");
		}
	},
	mounted() {
		this.swiper = new Swiper(this.$refs.slider, {
			effect: "fade",
			autoplay: {
				delay: this.delay,
				disableOnInteraction: false
			},
			allowTouchMove: false,
			navigation: {
				prevEl: ".navigation__button--prev",
				nextEl: ".navigation__button--next",
				disabledClass: "navigation__button--disabled"
			}
		});

		this.$smoothReflow({
			el: ".box__content *",
			property: "height",
			hideOverflow: false
		});

		this.swiper.on("slideChange", () => {
			this.currentIndex = this.swiper.realIndex;
			this.timestamp = Date.now();
		});

		const loop = () => {
			const msElapsed = Date.now() - this.timestamp;
			const percentage = msElapsed / this.delay;
			this.$refs.progressBar.style.transform = `scaleX(${percentage})`;
			window.requestAnimationFrame(loop);
		};

		loop();
	}
};
</script>

<style lang="scss" scoped>
.container {
	@include inner-container();
	background: red;
}
.ingredient-container {
	height: 798px;
	background-position: center;
	background-size: cover;
}

.content {
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 1;
	width: 100%;
	&__container {
		@include inner-container();
		padding-bottom: 128px;
	}
}

.box {
	width: 42%;
	padding: 32px;
	background-color: white;
	box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.06);

	&__title {
		margin: 0;
	}

	&__content {
	}
}

.meta {
	margin-top: 48px;
	display: flex;
	align-items: center;
	color: black;
	font-size: 14px;
	letter-spacing: 0;
}

.meter {
	width: 130px;
	height: 2px;
	background: rgba($black, 0.1);
	overflow: hidden;
}

.progress {
	background: $teal-light;
	height: 2px;
	transform-origin: left;
}

.page {
	margin-left: 16px;
	font-weight: 700;
}

.navigation {
	display: flex;
	margin-left: auto;
}

.navigation__button {
	cursor: pointer;
	&--next {
		margin-left: 16px;
	}

	&--disabled {
		opacity: 0.2;
	}
}
</style>
